// 西班牙语(Spanish)
export default {
  oneOneClass: "",
  learnPracEnFast: "",
  htOralClass: "",
  benefits: "",
  topicNumber: "",
  dailyBusinessAcademic: "",
  englishTutors: "",
  qualifiedTutors: "",
  nativeOkAllAges: "",
  oneOneLive: "",
  accessToRecord: "",
  personalizedPlan: "",
  ensureGoal: "",
  professional: "",
  nativeTeam: "",
  authenticLanguage: "",
  bgChecked: "",
  experiencedTeachers: "",
  assuredQuality: "",
  regularAssess: "",
  assuredSatisfaction: "",
  teamSizeAndRefund: "",
  curriculum: "",
  dailyTalks: "",
  beginnerInfo: "",
  lessonOverview: "",
  beginnerClassIntro: "",
  topicEx: "",
  beginnerTopicEx: "",
  mediateInfo: "",
  mediateClassIntro: "",
  mediateTopicEx: "",
  advancedInfo: "",
  advancedClassIntro: "",
  advancedTopicEx: "",
  businessLanguage: "",
  busElementInfo: "",
  busElementClassIntro: "",
  busElementTopicEx: "",
  busMediateInfo: "",
  busMediateClassIntro: "",
  busMediateTopicEx: "",
  ielts: "",
  languageTests: "",
  aHundredLessons: "",
  ieltsClassIntro: "",
  faq: "",
  questionCn: "",
  classLength: "",
  classInfoAndSuggest: "",
  lessonForm: "",
  lessonFormInfo: "",
  lessonPrepare: "",
  lessonPrepareInfo: "",
  support: "",
  limitedOffer: "",
  originalPrice: "",
  bookNow: "",
  successPurchase: "",
  trialEndAndGoOn: "",
  courseAdvisor: "",
  oneLastStep: "",
  ticketPrice: "",
  perPriceAndOrder: "",
  noThanks: "",
  unpaidAndProceed: "",
  halfPrice: "",
  languageEn: "",
  languageKo: "",
  languageEsp: "",
  languageFr: "",
  languageIt: "",
  languageRu: "",
  languageCn: "",
  languageJp: "",
  courseEn: "",
  courseKo: "",
  courseEsp: "",
  courseFr: "",
  courseIt: "",
  courseRu: "",
  courseCn: "",
  courseJp: "",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  coinSpecialOffer: "Oferta especial de recarga de monedas HT",
  buySomeAndGetExtra: "¡Compra algunos y obtén más!",
  balance: "Saldo",
  coins: "{number} monedas",
  coin: "{number} moneda",
  extraCoins: "{number} monedas extra",
  continue: "Continuar",
  byToppingUpYouAgree: "Al recargar, aceptas el acuerdo",
  topUpAgreement: "[Acuerdo de recarga]",
  htCoin: "Moneda HT",
  scanCodeToLog: "Escanea el código para iniciar sesión",
  bindYourHelloTalkAccount:
    "Usa la aplicación HelloTalk para escanear el código e iniciar sesión. Vincula tu cuenta HelloTalk y recarga.",
  itemSelection: "Selección de artículos",
  paymentAmount: "Cantidad",
  topUpSuccessful: "Recarga exitosa👏",
  totalCoinsNumber:
    "Has añadido con éxito {numberone} monedas y has recibido {numbertwo} monedas extra, con un total de {numberall} monedas.",
  ok: "OK",
  copyLinkToPay:
    "Copia el enlace y ábrelo con la aplicación HelloTalk para completar el pago.",
  paymentFailed: "Pago fallido",
  creditCardPay: "Paga con PayPal o tarjeta de crédito",
  creditCard: "Tarjeta de crédito",
};
